import { differenceInMonths, format } from 'date-fns';
import { Bar, ChartECOption, ChartRangeFilter } from '../types';

export interface GetChartXAxisOptionArgs {
  data: (Bar | null)[];
  numberOfLabels: number;
  rangeFilter: ChartRangeFilter;
  overrides?: { hide?: boolean };
}

export function getChartXAxisOption({
  data,
  rangeFilter,
  numberOfLabels,
  overrides,
}: GetChartXAxisOptionArgs): ChartECOption['xAxis'] {
  return [
    {
      show: !overrides?.hide,
      axisLabel: {
        fontSize: 9,
        fontFamily: 'Tenon',
        interval: data.length / numberOfLabels,
        fontWeight: 'bold',
        color: '#585f66',
        opacity: 0.7,
        align: 'center',
        formatter(index) {
          const dataPoint = data[Number(index)];
          if (!dataPoint) return '';
          const rangeMonthDiff = differenceInMonths(rangeFilter[1], rangeFilter[0]);
          const formatting = rangeMonthDiff >= 4 ? 'MMM yy' : 'MMM dd';
          return format(new Date(dataPoint.dateISO), formatting).toUpperCase();
        },
        showMaxLabel: true,
      },
      type: 'category',
      axisLine: { show: false },
      axisTick: { show: false },
    },
  ];
}
